import { render, staticRenderFns } from "./race.vue?vue&type=template&id=6969c71b&scoped=true&"
import script from "./race.vue?vue&type=script&lang=js&"
export * from "./race.vue?vue&type=script&lang=js&"
import style0 from "./race.vue?vue&type=style&index=0&id=6969c71b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6969c71b",
  null
  
)

export default component.exports